import { AboutUsTrustpilot } from "modules/sections/AboutUsTrustpilot";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { AboutUsTrustpilotProps } from "modules/sections/AboutUsTrustpilot";

const AboutUsTrustpilotSectionAdapter = ({
  sbEditable,
  blok: { title, subtitle, srcDesktop, srcMobile, height, alt, cardDesktopPosition },
}: ReactStoryblokComponent<AboutUsTrustpilotProps>) => (
  <AboutUsTrustpilot
    title={title}
    subtitle={subtitle}
    srcDesktop={srcDesktop}
    srcMobile={srcMobile}
    height={height}
    alt={alt}
    cardDesktopPosition={cardDesktopPosition}
    sbEditable={sbEditable}
  />
);
export default AboutUsTrustpilotSectionAdapter;
